
import BaseCheckbox from "@/components/base/BaseCheckbox.vue";
import BaseAlert from "@/components/base/BaseAlert.vue";
import useVuelidate from "@vuelidate/core";
import { helpers } from "@vuelidate/validators";
import { onMounted, ref, watch, computed, defineComponent, reactive } from "vue";
import { useBookingStore } from "@/store/booking";
import { TermTypeEnum, DirectionEnum } from "@/models/enums";
import { TermState } from "@/models/www/store/BookingState";
import contentService from "@/services/content.service";
import { WPContent } from "@/models/Content";

export default defineComponent({
  	components: {
    	BaseCheckbox,
    	BaseAlert,
  	},
  	setup() {
	  	
	  	const modeOfTravel = computed(() => { return bookingStore.booking.modeOfTravel });
	  	const route = computed(() => bookingStore.getRoute(DirectionEnum.Outward));
	  	
	  	const bookingStore = useBookingStore();
	  	
        const inputValue = computed({
			get(): boolean {
			
    			const checked = bookingStore.getTerm(`${TermTypeEnum.PetCrate}`)?.checked ?? false;
    			return checked;
			},
			set(value: boolean) {
				
				bookingStore.setTerm({ identifier: `${TermTypeEnum.PetCrate}`, checked: value } as TermState);
			},
		});
        
		const rules = {
			checked: {
				v: helpers.withMessage(
					() => 'You need to confirm that you are aware of the size and weight restrictions for our pet crate',
					() => { return inputValue.value || content.value === undefined }
				)
			},
		};

		const v$ = useVuelidate(rules, reactive({ checked: inputValue.value }));
		
		const content = ref<WPContent>();
		
		const fetchContent = () => {
			contentService
			.getContent("start", 
						modeOfTravel.value,
						"")
			.then((resp) => {
				content.value = resp[0];
			});
		};
		
		watch(modeOfTravel, () => {
			fetchContent();
		});
		
		onMounted(() => {
			fetchContent();
		});
		return { inputValue, content, TermTypeEnum, v$ };
  	}
});
